import azureDevOpsService from './azureDevOpsService';

const BASE = '/api/functional-coverage';

function authHeaders() {
  const pat = azureDevOpsService.getPat();
  return pat ? { 'X-Azure-Devops-Pat': pat } : {};
}

// Les écritures renvoient la vue fusionnée à jour ({ ok, id, data }) :
// la page remplace son état avec `data`, sans recharger.
async function send(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.error || `Erreur ${res.status}`);
  return payload;
}

const functionalCoverageService = {
  async load() {
    const res = await fetch(BASE, { headers: authHeaders() });
    const payload = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(payload.error || `Erreur ${res.status}`);
    return payload;
  },
  addFeature: (domain, fields) => send('POST', `/domains/${encodeURIComponent(domain)}/features`, fields),
  updateFeature: (featureId, fields) => send('PATCH', `/features/${encodeURIComponent(featureId)}`, fields),
  addCapability: (featureId, name) => send('POST', `/features/${encodeURIComponent(featureId)}/capabilities`, { name }),
  addComment: (featureId, text) => send('POST', `/features/${encodeURIComponent(featureId)}/comments`, { text }),
  updateCapability: (capabilityId, fields) => send('PATCH', `/capabilities/${encodeURIComponent(capabilityId)}`, fields),
  deleteCapability: (capabilityId) => send('DELETE', `/capabilities/${encodeURIComponent(capabilityId)}`),
  deleteFeature: (featureId) => send('DELETE', `/features/${encodeURIComponent(featureId)}`),
  restore: (id) => send('POST', `/removed/${encodeURIComponent(id)}/restore`),
};

export default functionalCoverageService;
